import { gql } from '@generated/gql';

gql(`
  fragment MoneyAmount on ChargeAmount {
    currency
    value
  }
`);

gql(`
  fragment DiscountDetails on Discount {
    credit {
      ... on AmountCredit {
        amount
      }
      ... on PercentageCredit {
        percentage
      }
    }
    description
    id
    qualified
    qualificationMessage
    creditAppliesAfter
    creditFrequency
  }
`);

gql(`
  fragment BroadbandDetails on BroadbandProductDetails {
    contractLength
    minimumTerm
    speeds {
      downstreamAverage
      downstreamMax
      downstreamMin
      guaranteedDownstream
      guaranteedUpstream
      type
      upstreamAverage
      upstreamMax
      upstreamMin
    }
    broadbandOnly
  }
`);

gql(`
  fragment EnergyDetails on EnergyProductDetails {
    unitRate2
    unitRate1
    standingCharge
    predefinedConsumption
    quoteType
    exitFees
    tariffEndDate
  }
`);

gql(`
  fragment InsuranceDocuments on InsuranceDocument {
    id
    name
    url
  }
`);

gql(`
  fragment ElectricityRequirements on ElectricityQuoteRequirement {
    electricVehicleTariffExpressionOfInterest
    estimatedAnnualConsumptionRegister1
    estimatedAnnualConsumptionRegister2
    meterType
    paymentMethod
    paymentOption
  }
`);

gql(`
  fragment GasRequirements on GasQuoteRequirement {
    estimatedAnnualConsumption
    paymentMethod
    paymentOption
  }
`);

gql(`
  fragment BroadbandRequirements on BroadbandQuoteRequirements {
    broadbandEquipment {
      ... on WholeHomeWifi {
        numEeros
      }
      ... on RouterOnly {
        router
      }
    }
    callingFeatures {
      callerDisplay
      exDirectory
      numberWithheld
      offPeakSaver
      peakSaver
    }
    lineCharacteristics {
      cli
      networkType
      appointmentRequired
    }
    includeVoip
  }
`);

gql(`
  fragment BundleQuote on Quote {
    id
    selected
    totalMonthlyCost {
      ...MoneyAmount
    }
    discounts {
      ...DiscountDetails
    }
    allProductCharges {
      amount {
        ...MoneyAmount
      }
      description
      name
      type
    }
    product {
      id
      type
      subtype
      name
      description
      details {
        ... on BroadbandProductDetails {
          ...BroadbandDetails
        }
        ... on EnergyProductDetails {
          ...EnergyDetails
        }
        ... on BoilerCoverProductDetails {
          documents {
            ...InsuranceDocuments
          }
        }
        ... on IncomeProtectorProductDetails {
          documents {
            ...InsuranceDocuments
          }
        }
      }
      charges {
        type
        amount {
          ...MoneyAmount
        }
        name
        description
      }
    }
    status {
      reasons {
        description
        type
      }
      status
    }
    requirements {
      id
      requirement {
        ... on ElectricityQuoteRequirement {
          ...ElectricityRequirements
        }
        ... on GasQuoteRequirement {
          ...GasRequirements
        }
        ... on BroadbandQuoteRequirements {
          ...BroadbandRequirements
        }
      }
    }
  }
`);

gql(`
  fragment SupplyAddress on Address {
    id
    buildingName
    buildingNumber
    county
    department
    dependentLocality
    dependentThoroughfare
    doubleDependentLocality
    organisation
    postcode
    postTown
    subBuilding
    thoroughfare
    uprn
  }
`);

gql(`
  fragment BasketDetails on BasketDetails {
    accountId
    createdAt
    hasSmartmeter
    isExistingCustomer
    occupancyType
    submittedAt
    supplyAddress {
      ...SupplyAddress
    }
  }
`);

gql(`
  fragment BasketStatus on BasketStatus {
    isValidSelection
    unavailableStatuses {
      status
      reasons {
        type
        description
      }
    }
  }
`);

gql(`
  fragment BundleBasket on Basket {
    id
    energy {
      ...EnergyBasket
    }
    mobile {
      ...BasketMobileFragment
    }
    details {
      ...BasketDetails
    }
    monthlyCost {
      ...MoneyAmount
    }
    discounts {
      description
      qualified
      id
      creditFrequency
      credit {
        ... on AmountCredit {
          amount
        }
        ... on PercentageCredit {
          percentage
        }
      }
    }
    depositRequirement {
      depositRequired
      depositAmount {
        currency
        value
      }
    }
    quotes {
      ...BundleQuote
    }
    selectedQuotes {
      ...BundleQuote
    }
    willCreditCheck
    isPropertyAlreadySupplied
    basketStatus {
      ...BasketStatus
    }
  }
`);

gql(`
  fragment CashbackCalculatorDetails on CashbackCalculatorDetails {
    estimatedCashbackValue
    useCashbackValueInComms
    data
  }
`);

const getBundleBasket = gql(`
  query GetBasket($basketId: ID!) {
    basket(id: $basketId) {
      ...BundleBasket
    }
    attributionDetails(basketId: $basketId) {
      ...AttributionDetails
    }
    cashbackCalculatorDetails(basketId: $basketId) {
      ...CashbackCalculatorDetails
    }
  }
`);

const requoteBasket = gql(`
  mutation RequoteBasket($basketId: ID!) {
    requoteBasket(basketId: $basketId) {
      ...BundleBasket
    }
  }
`);

export { getBundleBasket, requoteBasket };
